import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';


export default function CtitemListTableHeader(){
    const {rolename} = useSelector((state)=>state.headerslice.userprofileInfo);
    return (
      
      <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%', padding: 1, backgroundColor: 'primary.lighter' }}>
          <Grid item lg={4} xs={1} ><Typography variant="h5"> Composition </Typography></Grid>
          <Grid item lg={2} xs={1} ><Typography variant="h5"> Quantity </Typography></Grid>
          {rolename==='PHARMA_OMS_QA'?<></>
          :<>
            <Grid item lg={2} xs={1} ><Typography variant="h5"> Number of Items </Typography></Grid>
            <Grid item lg={2} xs={1} ><Typography variant="h5"> Demand </Typography></Grid>
          </>}
      </Grid>
      
    )
}